import { Icon, Menu, MenuItem, Popover, Tooltip } from '@blueprintjs/core'
import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/icons/lib/css/blueprint-icons.css'
import { css, cx } from 'emotion'
import produce from 'immer'
import 'katex/dist/katex.min.css'
import 'normalize.css/normalize.css'
import React, { Component, useCallback, useRef, useState } from 'react'
import { InlineMath } from 'react-katex'
// import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import Markdown from 'react-markdown'
import { walk } from 'react-sortable-tree'
import MathPlugin from 'remark-math'
import TermPlugin from 'remark-terms'
import UnderlinePlugin from 'remark-underline'
import WikiPlugin from 'remark-wiki-link'
import v from 'voca'
import { OverlayProps } from '../../../../helper/configs'
import { globalOnDemandVars } from '../../../../helper/context'
import { hasScrollbarIfHover } from '../../../../helper/CSSclasses'
import {
  getHighlightClass,
  getParsedText,
  logicSymbols3,
  openNewWindowAtWindow2ByPath,
  truncateDefault
} from '../../../../helper/functions'
import { nodeDataToLeftIcon } from '../../../commonInterface/searchBar'
import { getNodeKey } from '../../window1/functions'
import MediaBlock, { MediaBlockWithoutThumbnail } from '../mediaBlock'
import { useTranslation } from 'react-i18next'

// const WrapperForLoader = Loadable({
//   // 여기 helper 루트 수정해야함
//   loader: () => import('../../../../helper/WrapperForLoader.jsx'),
//   loading: Loading
// })

// blueprint package에서 customEditableText 파일에서 import해서 쓰는 파일임

class MarkDownWrapper extends Component {
  shouldComponentUpdate (nextProps, nextState) {
    return this.props.children !== nextProps.children
  }

  render () {
    return <Markdown
      className={this.props.className}
      escapeHtml unwrapDisallowed disallowedTypes={this.props.disallowedTypes}
      plugins={this.props.plugins}
      renderers={this.props.renderers}
    >
      {this.props.children}
    </Markdown>
  }
}

const _className = css`overflow: hidden;`
const _renderError = (error) => {
  const string = `${error.name}${'position' in error ? `: check position ${error.position} in $ $, or if you want to use just $, replace $ with \\$` : ''}`
  return (
    <Tooltip content={string} {...OverlayProps}>
      <span className={css`background-color: var(--gray3);`}>(LaTeX Error)</span>
    </Tooltip>
  )
}
const _inlineMath = props => (<InlineMath
  errorColor={'var(--gray3);'}
  renderError={_renderError}
>{props.value}</InlineMath>)
// TODO 이거 math 작동 안돼서(\n이 안들어가면) 처리해놓은거 잊으면 안됨 - 나중에 수정하기
const _math = props => (<InlineMath
  errorColor={'var(--gray3);'}
  renderError={_renderError}
>{props.value}</InlineMath>)

const _wikiLink = ({ value, data: { alias } }) => {
  const { t } = useTranslation()

  const [popoverDisabled, setPopoverDisabled] = useState(true)
  const linkedNodes = useRef([])
  const onMouseDown = useCallback(
    (e) => {
      e.preventDefault()

      const parsedValue = getParsedText(value)

      const treeData = globalOnDemandVars.isPixelMode() ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()

      const exactlyMatched = []
      const partlyMatched = []
      walk({
        treeData,
        getNodeKey,
        ignoreCollapsed: false,
        callback: ({ node, path, parentNode }) => {
          const parsedNodeTitle = getParsedText(node.title)
          if (v.includes(parsedNodeTitle, parsedValue)) {
            const nodeInfo = { node, path, parentNode }
            if (parsedNodeTitle === parsedValue) {
              exactlyMatched.push(nodeInfo)
              // eslint-disable-next-line no-useless-escape
            } else if (v.matches(parsedNodeTitle, ('[^\\[]' + parsedValue + '[^\\]]' + '|^' + parsedValue + '|' + parsedValue + '$'))) {
              partlyMatched.push(nodeInfo)
            }
          }
        }
      })

      if (exactlyMatched.length) {
        linkedNodes.current = exactlyMatched
        if (linkedNodes.current.length === 1) {
          const matchedNodeInfo = linkedNodes.current[0]
          setPopoverDisabled(true)
          openNewWindowAtWindow2ByPath(matchedNodeInfo.path)
        } else {
          setPopoverDisabled(false)
        }
      } else {
        linkedNodes.current = partlyMatched
        if (linkedNodes.current.length === 1) {
          const matchedNodeInfo = linkedNodes.current[0]
          setPopoverDisabled(true)
          openNewWindowAtWindow2ByPath(matchedNodeInfo.path)
        } else {
          setPopoverDisabled(false)
        }
      }
    },
    [value]
  )

  return <Popover {...OverlayProps} minimal position={'bottom-left'} disabled={popoverDisabled} interactionKind={'click'} content={<Menu>{
    linkedNodes.current.length ? linkedNodes.current.map((nodeInfo) => (
      <MenuItem
        key={nodeInfo.node.id}
        // label={nodeData.key}
        onClick={() => { openNewWindowAtWindow2ByPath(nodeInfo.path) }}
        title={nodeInfo.node.title}
        text={truncateDefault(nodeInfo.node.title)}
        icon={nodeDataToLeftIcon(nodeInfo)}
        shouldDismissPopover
      />
    )) : <span className={css`color: var(--gray6);`}>{t('Nothing Found')}</span>
  }</Menu>}>
    <a className={css`background-color: rgba(213, 247, 173, 0.25); border-radius: 4px; padding: 0 4px; color: var(--reverseColor);`} onMouseDown={onMouseDown}>
      <Icon icon={'link'} iconSize={16} color={'var(--gray4)'} className={css`padding-bottom: var(--s-3);`} />
      {alias}
    </a></Popover>
}

const _wikiLink2 = ({ data: { alias } }) => alias
const _textRenderer = ({ children: string }) => {
  const result = []
  const length = string.length
  for (let i = 0; i < length; i++) {
    const char = string[i]
    if (logicSymbols3.some((symbol) => (symbol === char))) {
      result.push(<span key={i} className={css`color: #106BA3;`}>{char}</span>)
    } else {
      result.push(char)
    }
  }
  return <React.Fragment>{result}</React.Fragment>
}
const numberRegExp = /^\d+$/
const _linkRenderer = (data) => {
  // if (process.env.NODE_ENV !== 'production') {
  //   console.tron.display({
  //     name: 'linkRenderer',
  //     value: {
  //       href: data.href,
  //       title: data.title,
  //       value,
  //       keys: Object.keys(data)
  //     }
  //     // , important: true
  //   })
  // }
  const value = data.children[0] ? (data.children[0].props.value || '') : ''

  const href = data.href
  const isHighlight = numberRegExp.test(href) || href.startsWith('#')

  let highlightClassName
  if (numberRegExp.test(href)) {
    switch (Number(href)) {
      case 1:
        highlightClassName = 'highlight1'
        break
      case 2:
        highlightClassName = 'highlight2'
        break
      case 3:
        highlightClassName = 'highlight3'
        break
      case 4:
        highlightClassName = 'highlight4'
        break
      case 5:
        highlightClassName = 'highlight5'
        break
      default:
        highlightClassName = 'highlight5'
        break
    }
  }

  return isHighlight ? (
    <span className={highlightClassName}>{value}</span>
  ) : (
    <a href={data.href}>{value}</a>
  )
}
const _linkRenderer2 = (data) => {
  const value = data.children[0] ? (data.children[0].props.value || '') : ''
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'linkRenderer2',
      preview: value,
      value: {
        href: data.href,
        title: data.title
      }
      // , important: true
    })
  }

  return _textRenderer({ children: '[' + value + ']' })
}
const _renderers = {
  text: _textRenderer,
  thematicBreak: () => (<hr className={css`width: 10em; margin-top: 0.75em !important; margin-bottom: 0.75em !important;`} />),
  inlineMath: _inlineMath,
  math: _math,
  image: MediaBlock,
  wikiLink: _wikiLink,
  link: _linkRenderer,
  linkReference: _linkRenderer2,
  underline: (data) => {
    const value = data.children[0] ? (data.children[0].props.value || '') : ''
    return <span className={css`text-decoration: underline;`}>{value}</span>
  },
  delete: (data) => {
    const value = data.children[0] ? (data.children[0].props.value || '') : ''
    return <span className={css`text-decoration: line-through;`}>{value}</span>
  },
  term_1: (data) => {
    const value = data.children[0] ? (data.children[0].props.value || '') : ''
    return <>
      <span className={css`color: #FF7373;`}>{'{{'}</span>
      <span>{_textRenderer({ children: value })}</span>
      <span className={css`color: #FF7373;`}>{'}}'}</span>
    </>
  }

}
const _renderers2 = produce(_renderers, draft => {
  draft.image = MediaBlockWithoutThumbnail
  draft.wikiLink = _wikiLink2
})
const clozeRendererForQuestionPart = (data) => {
  return <span className={css`color: #F55656;`}>{'{{...}}'}</span>
}
const _renderers1InQuestionPart = produce(_renderers, draft => {
  draft['term_1'] = clozeRendererForQuestionPart
})
const _renderers2InQuestionPart = produce(_renderers2, draft => {
  draft['term_1'] = clozeRendererForQuestionPart
})

const _plugins = [MathPlugin, WikiPlugin, UnderlinePlugin, [TermPlugin, [{
  name: 'term_1',
  open: '{{',
  close: '}}',
  element: 'span',
  class: 'term-1'
}]]]

// @perf
class CustomEditableTextContent extends Component {
  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.style.height !== nextProps.style.height || this.props.children !== nextProps.children || this.props.boxHighlight !== nextProps.boxHighlight
    )
  }

  // shouldComponentUpdate (nextProps) {
  //   return (nextProps.children !== this.props.children)
  // }

  _disallowedTypes

  _plugins

  _renderers

  _className

  render () {
    return (
      <div className={cx('bp3-editable-text-content bp3-multiline', css`position: absolute; overflow: visible !important; height: fit-content; display: flex; width: 100%;
    // ${!this.props.children ? 'padding-bottom: 1px;' : ''}`)}
        // ref={props.refCalc}
      >
        <div style={this.props.style} className={cx(hasScrollbarIfHover, css`overflow: auto; flex: none; max-width: 100%;
    & * {
    margin: 0px !important;
    // margin-bottom: 1px !important;
    }
    & ol {
    list-style-type: decimal;
    padding-inline-start: 20px;
    }
    & ul {
    list-style-type: disc;
    padding-inline-start: 23px;
    }
    & h1 {
    padding-bottom: 3px;
    }
    & h2, & h3 {
    padding-bottom: 2px;
    }
    & h4, & h5, & h6 {
    padding-bottom: 1px;
    }
    & > div {
    overflow: visible !important;
    }
    & div {
    overflow: visible;
    }
        `)}>
          <div ref={this.props.refCalc}>
            {!this.props.children ? <p>{'\n'}</p>
              : <MarkDownWrapper className={_className}
                  plugins={_plugins}
                  renderers={this.props.withoutThumbnail ? (this.props.isQuestionPart ? _renderers2InQuestionPart : _renderers2) : (this.props.isQuestionPart ? _renderers1InQuestionPart : _renderers)}
                  children={this.props.children} />
            }
          </div>
        </div>

        {(this.props.boxHighlight && this.props.boxHighlight.boolean) ? <div className={cx(css`width: 100%; height: var(--s-1); margin-left: var(--s-2);`, getHighlightClass(this.props.boxHighlight.option))} /> : null}
      </div>
    )
  }
}

export default CustomEditableTextContent

// @perf
class CustomEditableTextContent2 extends Component {
  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.style.height !== nextProps.style.height || this.props.children !== nextProps.children
    )
  }

  // shouldComponentUpdate (nextProps) {
  //   return (nextProps.children !== this.props.children)
  // }

  _disallowedTypes

  _plugins

  _renderers

  _className

  render () {
    return (
      <div style={this.props.style} className={cx('bp3-editable-text-content bp3-multiline', hasScrollbarIfHover, css`position: absolute;
    // ${!this.props.children ? 'padding-bottom: 1px;' : ''}
    & * {
    margin: 0px !important;
    // margin-bottom: 1px !important;
    }
    & ol {
    list-style-type: decimal;
    padding-inline-start: 20px;
    }
    & ul {
    list-style-type: disc;
    padding-inline-start: 23px;
    }
    & h1 {
    padding-bottom: 3px;
    }
    & h2, & h3 {
    padding-bottom: 2px;
    }
    & h4, & h5, & h6 {
    padding-bottom: 1px;
    }
    & > div {
    overflow: visible !important;
    }
    & div {
    overflow: visible;
    }
    `)}
        // ref={props.refCalc}
      >
        <div ref={this.props.refCalc}>
          {!this.props.children ? <p>{'\n'}</p>
            : <MarkDownWrapper className={_className}
                plugins={_plugins}
                renderers={this.props.withoutThumbnail ? (this.props.isQuestionPart ? _renderers2InQuestionPart : _renderers2) : (this.props.isQuestionPart ? _renderers1InQuestionPart : _renderers)}
                children={this.props.children} />
          }
        </div>
      </div>
    )
  }
}

export { CustomEditableTextContent2 }
